const PersonalIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 15.5833C18.1208 15.5833 19.2164 15.251 20.1482 14.6283C21.0801 14.0057 21.8064 13.1207 22.2353 12.0852C22.6642 11.0498 22.7764 9.91038 22.5578 8.81116C22.3391 7.71193 21.7994 6.70223 21.0069 5.90973C20.2144 5.11723 19.2047 4.57754 18.1055 4.35889C17.0063 4.14024 15.8669 4.25246 14.8315 4.68135C13.796 5.11025 12.911 5.83656 12.2883 6.76844C11.6657 7.70032 11.3333 8.79591 11.3333 9.91667C11.3333 11.4196 11.9304 12.8609 12.9931 13.9236C14.0558 14.9863 15.4971 15.5833 17 15.5833Z"
        fill="#181717"
      />
      <path
        d="M25.5 29.75C25.8757 29.75 26.2361 29.6007 26.5017 29.3351C26.7674 29.0694 26.9167 28.709 26.9167 28.3333C26.9167 25.7033 25.8719 23.1809 24.0121 21.3212C22.1524 19.4614 19.6301 18.4167 17 18.4167C14.3699 18.4167 11.8476 19.4614 9.98786 21.3212C8.12812 23.1809 7.08334 25.7033 7.08334 28.3333C7.08334 28.709 7.23259 29.0694 7.49827 29.3351C7.76394 29.6007 8.12428 29.75 8.5 29.75H25.5Z"
        fill="#181717"
      />
    </svg>
  );
};

export default PersonalIcon;
